export const GA_TRACKING_ID = 'AW-18230806173'

// https://developers.google.com/analytics/devguides/collection/gtagjs/pages
export const pageview = url => {
  window.gtag('config', GA_TRACKING_ID, {
    page_path: url,
  })
}

// https://developers.google.com/analytics/devguides/collection/gtagjs/events
export const event = ({ action, category, label, value }) => {
  window.gtag('event', action, {
    event_category: category,
    event_label: label,
    value: value,
  })
}

const cookieNames = ['gclid', 'gbraid', 'wbraid'];

export const gtag_report_conversion = (id, user_data = null) => {
  const callback = function () {
    if (typeof(url) != 'undefined') {
      window.location = url;
    }
  };

  const params = {
    'send_to': id,
    'value': 1.0,
    'currency': 'USD',
    'event_callback': callback
  }

  if (user_data) {
    params.user_data = user_data
  }

  /*const cookies = Object.fromEntries(
      document.cookie.split('; ').map(c => c.split('='))
  );

  ['gclid', 'gbraid', 'wbraid'].forEach(cookieName => {
    const cookie = cookies[cookieName];
    if (cookie) {
      params[cookieName] = cookie;
    }
  })*/

  window.gtag('event', 'conversion', params);
  //console.log("gtag_report_conversion", id, params)
  return false;
}